import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrackResolver} from './track-resolver';
import {TrackRoutingModule} from './track-routing.module';
import {ComponentModule} from '../component/component.module';
import {TrackComponent} from './track.component';
import {TrackService} from './track.service';
import {MatIconModule} from '@angular/material/icon';
import {AdminModule} from '../admin/admin.module';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    TrackRoutingModule,
    ComponentModule,
    MatButtonModule,
    MatIconModule,
    AdminModule
  ],
  declarations: [
    TrackComponent
  ],
  providers: [
    TrackResolver,
    TrackService
  ]
})
export class TrackModule {
}
